<script>
  /**
   * @type {"vertical"|"horizontal"}
   */
  export let direction

  export let gap = ".5rem"

  export let alignItems = "start"

  export let justifyContent = "start"

  export let style = ""
</script>

<div
  class="stack"
  style="--gap: {gap}; --alignItems: {alignItems}; --justifyContent: {justifyContent}; {style}"
  class:vertical={direction === "vertical"}
  class:horizontal={direction === "horizontal"}
>
  <slot/>
</div>

<style>
  .stack {
    display: flex;
    gap: var(--gap);
    align-items: var(--alignItems);
    justify-content: var(--justifyContent);
  }

  .vertical {
    flex-direction: column;
    gap: var(--gap);
    width: 100%;
  }

  .horizontal {
    display: flex;
    flex-direction: row;
  }
</style>
